import { IAppState } from '../../redux';
import { IPublicationTokens } from '../../redux/reducers';

export const selectPublicationTokens = (state: IAppState): IPublicationTokens | null => {
  return state.publishTerms.publicationTokens;
};
